import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { State } from "redux/state";
import { Omit } from "utils/Types";
import { useProfile } from "utils/useProfile";
import { SecondaryNavProps, SecondaryNavView } from "../components/SecondaryNavView";

export type SecondaryNavContainerProps = Omit<SecondaryNavProps, "user" | "asUser" | "location">;

export const SecondaryNavContainer: FC<SecondaryNavContainerProps> = props => {

    const { organizationId, loading } = props;

    const user = useProfile();
    const asUser = useSelector<State, boolean>(state => state.auth.asUser);
    const location = useLocation().pathname;

    return (
        <SecondaryNavView
            items={props.items}
            user={user}
            asUser={asUser}
            navType={props.navType}
            organizationId={organizationId}
            app={props.app}
            location={location}
            loading={loading}
            warningMessage={props.warningMessage}
        />
    );
};
